<template>
  <div>
    <div
      v-for="(option, index) in step.options"
      v-if="step.welcome_option === 'yes-no'">
      <div v-if="index === 0" class="klickbox-edit-title">{{ $t('edit.canvas.positive_button_text') }}</div>
      <div v-else class="klickbox-edit-title">{{ $t('edit.canvas.negative_button_text') }}</div>
      <input
        class="btn"
        type="text"
        style="padding-top:25px; margin-top:-20px;"
        @change="optionUpdateText({ event: $event, id: option.id })"
        :value="option.label" />
    </div>
    <div
      v-if="step.welcome_option === 'start'">
      <div class="klickbox-edit-title">{{ $t('edit.canvas.start_button_text') }}</div>
      <input
        class="btn"
        type="text"
        style="padding-top:25px; margin-top:-20px;"
        @change="optionUpdateText({ event: $event, id: step.options[0].id })"
        :value="step.options[0].label" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: [
    'step',
  ],
  methods: mapActions([
    'optionUpdateText',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Welcome.vue?465c28ad
 **/